import Vue from 'vue'
import Router from 'vue-router'
import Vuetify from 'vuetify'
import money from '../lib/v-money'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Hello from '@/components/Inicio'
import ClientesLista from '@/components/ClientesLista'
import ComprobantesLista from '@/components/ComprobantesLista'
import Compras from '@/components/Compras'
import Depositos from '@/components/Depositos'
import ReporteVentas from '@/components/ReporteVentas'
import CatalogoLista from '@/components/CatalogoLista'
import GuiaRemisionLista from '@/components/GuiaRemisionLista'

Vue.component('login', require('@/components/login').default)
Vue.component('cambiar-clave', require('@/components/CambiarClave').default)
Vue.component('venta-producto', require('@/components/VentaProducto').default)
Vue.component('venta-seleccionar-producto', require('@/components/VentaSeleccionarProducto').default)
Vue.component('venta-manual', require('@/components/VentaManual').default)
Vue.component('cliente', require('@/components/Cliente').default)
Vue.component('clientes-lista', require('@/components/ClientesLista').default)
Vue.component('comprobante', require('@/components/Comprobante').default)
Vue.component('comprobantes-lista', require('@/components/ComprobantesLista').default)
Vue.component('catalogo', require('@/components/Catalogo').default)
Vue.component('guia-remision', require('@/components/GuiaRemision').default)
Vue.component('guia-remision-lista', require('@/components/GuiaRemisionLista').default)
Vue.use(Router)
Vue.use(Vuetify)
Vue.use(money)

if (localStorage.getItem('ventasTokenId') === null) {
  localStorage.setItem('ventasTokenId', '')
}
if (localStorage.getItem('ventasLocal') === null) {
  localStorage.setItem('ventasLocal', '')
}
if (localStorage.getItem('ventasVars') === null) {
  localStorage.setItem('ventasVars', '')
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Hello
    },
    {
      path: '/clientes',
      name: 'Clientes',
      component: ClientesLista
    },
    {
      path: '/ventas',
      name: 'Ventas',
      component: ComprobantesLista
    },
    {
      path: '/compras',
      name: 'Compras',
      component: Compras
    },
    {
      path: '/depositos',
      name: 'Depositos',
      component: Depositos
    },
    {
      path: '/reportes',
      name: 'ReporteVentas',
      component: ReporteVentas
    },
    {
      path: '/catalogo',
      name: 'Catalogo',
      component: CatalogoLista
    },
    {
      path: '/guias',
      name: 'GuiasRemision',
      component: GuiaRemisionLista
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js